<template>
  <div  class="scale-container" style="height: 96vh;width: 94vw">

    <el-container class="contain-6" style="padding: 10px 10px">


      <el-drawer
          :title="titleProm"
          :visible.sync="dialogTableVisible2"
          :modal="false"
          direction="rtl"
          size="80%">
        <iframe frameborder="0" style="width:100%; height:900px;" :src="srcProm"></iframe>

      </el-drawer>
      <div class="bbb">
        <div v-show="echartShow" style="display: flex">

<!--          <div ref="chart2" style="width: 800px; height: 230px;"></div>-->

        </div>
        <!-- 添加显示/隐藏开关和Bl组件 -->
<!--        <div>-->
<!--          <div style="margin: 1px 0;">-->
<!--            <el-switch-->
<!--                style="margin-top:1px"-->
<!--                v-model="echartShow"-->
<!--                active-text="显示图表"-->
<!--                inactive-text="隐藏图表"-->
<!--                :width="60">-->
<!--            </el-switch>-->
<!--          </div>-->
<!--        </div>-->
        <el-dialog :visible.sync="dialogChartVisible" width="85%" :title="'数据趋势分析' + this.selectText">
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <!-- 上一天按钮 -->
            <el-button size="mini" @click="switchDay(-1)">上一天</el-button>

            <!-- 下一天按钮 -->
            <el-button size="mini" @click="switchDay(1)">下一天</el-button>
          </div>

          <div style="display: flex">
            <div ref="chart" style="width: 60vw; height: 530px"></div>
            <!-- 日志表格保持不变 -->
            <el-table :data="mylogData" max-height="300" size="mini">
              <el-table-column prop="created_time" label="操作时间" width="150"></el-table-column>
              <el-table-column prop="operation_action" label="操作动作" width="100">
                <template slot-scope="{row}">
                  {{ row.fronted_operator_platform }}{{ row.operation_action }}
                </template>
              </el-table-column>
              <el-table-column label="操作日志详情">
                <template slot-scope="scope">
                  <div v-for="(log, index) in scope.row.operation_log" :key="index">
                    <span>{{ log.name }}: {{ log.before }} → {{ log.after }}</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-dialog>
        <el-header style="display: flex;height: 40px;">

          <el-select v-model="valueGame" placeholder="游戏选择" size="mini"
                     style="margin-top: 5px;align-items: center;display: flex"
                     filterable clearable allow-create>
            <el-option
                v-for="item in optionsGame"
                :key="item"
                :label="item"
                :value="item">
            </el-option>
          </el-select>
          <el-input v-model="valueAccount" placeholder="请输入账户ID" size="mini" clearable
                    style="margin-left: 5px;margin-top: 5px;width: 200px;align-items: center;display: flex">

          </el-input>
          <el-input v-model="valueProm" placeholder="请输入广告ID" size="mini" clearable
                    style="margin-left: 5px;margin-top: 5px;width: 200px;align-items: center;display: flex">

          </el-input>
          <el-input v-model="person" placeholder="请输入投手" size="mini" clearable
                    style="margin-left: 5px;margin-top: 5px;width: 200px;align-items: center;display: flex">

          </el-input>

          <span class="style-title">消耗:</span>
          <el-date-picker
              v-model="value1"
              type="date"
              style="margin-left: 5px;margin-top: 4px;width: 180px;align-items: center;display: flex"
              value-format="yyyy-MM-dd"
              size="mini" clearable
              placeholder="选择日期时间">
          </el-date-picker>

          <span class="style-title">收入:</span>
          <el-date-picker
              v-model="value6"
              type="datetime"
              style="margin-left: 2px;margin-top: 4px;width: 180px;align-items: center;display: flex"
              value-format="yyyy-MM-dd HH:00:00"
              size="mini" clearable
              placeholder="选择日期时间">
          </el-date-picker>

          <el-button size="mini"
                     style="margin-left: 6px;height: 30px;margin-top:8px;background-color: #f4f4f5;color: black"
                     @click="search(true)" icon="el-icon-refresh">
            刷新
          </el-button>
          <el-select
              v-model="selectedHourDisplays"
              multiple
              collapse-tags
              size="mini" style="margin-left: 10px; margin-top: 8px; width: 200px;"
              placeholder="选择小时数据显示"
              @change="handleHourDisplayChange"
          >
            <el-option
                v-for="option in hourDisplayOptions"
                :key="option.value"
                :label="option.label"
                :value="option.value">
            </el-option>
          </el-select>

        </el-header>
        <el-table
            v-loading="loading"
            ref="tableData1"
            :data="totalData"
            stripe
            border
            :key="tableKey"
            max-height="85vh"
            height="85vh"
            style="margin-top: 8px; width: 99%; font-size: 11px;"
            @cell-dblclick="rowClickEvent"
            @cell-click="contextClick"
            :header-cell-style="{background:'rgba(244,244,245,0)',color:'#323335', fontSize: '11px', padding: '4px 0'}"
            :cell-style="{padding: '2px 4px'}"
            size="mini"
            highlight-current-row
            row-key="id"
            lazy
            @sort-change="sortMethod"
            :load="load"
            :row-class-name="tableRowClassName"
            :expand-row-keys="expandedRows"
            @expand-change="handleExpandChange"
            :scrollbar-always-on="true"
        >

          <el-table-column label="收藏" width="45" prop="shoucang" align="center" fixed>
            <template slot-scope="{ row }">
              <i
                  :class="isFavorite(row) ? 'el-icon-star-on' : 'el-icon-star-off'"
                  :style="{ color: getStarColor(row) ,  fontSize: '15px' }"
                  @click="toggleFavorite(row)"            style="cursor: pointer;"
              ></i>
            </template>
          </el-table-column>
<!--          <el-table-column type="expand" label="操作" width="60" >-->
<!--            <template slot-scope="props">-->
<!--              <div style="padding: 10px;">-->
<!--                <el-button size="mini" @click="jump(props.row)">跳转</el-button>-->
<!--                <el-button-->
<!--                    size="mini"-->
<!--                    @click="chartOpen(props.row)"-->
<!--                    type="primary"-->
<!--                    :disabled="chartLoading"-->
<!--                    :loading="chartLoading"-->
<!--                >-->
<!--                  {{ chartLoading ? '加载中...' : '查看' }}-->
<!--                </el-button>-->
<!--                <el-button size="mini" @click="chartOpen2(props.row)" type="primary">查看表格</el-button>-->
<!--              </div>-->
<!--            </template>-->
<!--          </el-table-column>-->

          <el-table-column
              prop="gameName"
              label="游戏名"
              v-if="colOptions.includes('gameName')"
              min-width="110"
              fixed="left"
              show-tooltip-when-overflow
          >
            <template slot-scope="{row}">
              <span :class="{'summary-fixed': row.gameName === '汇总数据'}">
                {{ row.gameName }}
              </span>
            </template>
          </el-table-column>

          <el-table-column
              prop="accountId"
              label="账号id"
              fixed="left"
              min-width="112"
          >
            <template slot-scope="{row}">
              <span class="promotion">{{ row.accountId }}</span>
            </template>
          </el-table-column>

          <el-table-column
              prop="promotionId"
              label="广告id"
              min-width="115"
              fixed="left"
              v-if="colOptions.includes('promotionId')"
          >
            <template slot-scope="{row}">
              <span class="promotion">{{ row.promotionId }}</span>
            </template>
          </el-table-column>

          <el-table-column
              prop="materialId"
              fixed="left"
              label="创意id"
              min-width="121"
              v-if="colOptions.includes('materialId')"
          >
            <template v-slot="scope">
              <span class="promotion">{{ scope.row.materialId }}</span>
            </template>
          </el-table-column>

          <el-table-column
              prop="tfPerson"
              fixed="left"
              label="投放人员"
              v-if="colOptions.includes('tfPerson')"
              min-width="75"
          >
          </el-table-column>

          <el-table-column
              prop="status"
              label="状态"
              min-width="140">
            <template slot-scope="{row}">
              <span v-if="row.status === '投放中'" style="color: green;">●</span>
              {{ row.status || '-' }}   <span v-if="row.auto_acquisition_budget && !isNaN(row.auto_acquisition_budget)" style="font-size: 10px">{{row.auto_acquisition_budget/100}}</span>

              <el-tooltip v-if="row.autoStatus" :content="row.auto_acquisition_status_message || ''" placement="top">
                <i v-if="row.autoStatus==='一键起量中'" class="el-icon-loading" style="color: #409EFF; cursor: pointer; font-size: 14px;"></i>
                <i v-else-if="row.autoStatus==='一键起量完成'" class="el-icon-circle-check" style="color: #67C23A; cursor: pointer; font-size: 14px;"></i>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column
              prop="statCost"
              label="实时消耗"
              min-width="100"
              fixed="left"
              v-if="colOptions.includes('statCost')"
          >
            <template slot-scope="{row}">
              <span v-if="row.statCost===9999999">{{ "-" }}</span>
              <span v-else><span v-if="row.gameName==='汇总数据'">{{row.totalCost ? row.totalCost.toFixed(2) : '0.00'}}</span>
              <span v-else >{{row.cost !== undefined ? row.cost : row.totalCost}}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column
              prop="acquisitionCost"
              label="起量消耗"
              min-width="85"
              fixed="left"
              v-if="colOptions.includes('statCost')"
          >
            <template slot-scope="{row}">
              <span v-if="row.statCost===9999999">{{ "-" }}</span>
              <span v-else style="color: #969AA0">{{ row.acquisitionCost || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="sumRoi"
              label="创意ROI"
              min-width="70"
              fixed="left"
              v-if="colOptions.includes('sumRoi')"
          >
            <template slot-scope="{row}">
              <span v-if="row.gameName==='汇总数据'">{{ getSummaryRoi(row) }}</span>
              <span v-else>{{ row.mini_game_income_roi_1 !== undefined ? row.mini_game_income_roi_1 : (row.totalRoi || '-') }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="sumRoi"
              label="广告ROI"
              min-width="70"
              fixed="left"
              v-if="colOptions.includes('sumRoi')"
          >
            <template slot-scope="{row}">
              <span v-if="row.gameName==='汇总数据'"></span>
              <span v-else>{{ row.income_roi_1_24h_pla || '-' }}</span>
            </template>
          </el-table-column>

          <el-table-column
              prop="deepConversionWorthRate"
              label="出价"
              min-width="80"
              fixed="left"
              v-if="colOptions.includes('getPrice')"
          >
            <template slot-scope="{row}">
              {{  row.deep_conversion_worth_rate ? row.deep_conversion_worth_rate : '-' }}
              <span style="color:#909399;font-size: 11px">
                <span v-if="row.deep_coversion_worth_goal_cn === '首日变现ROI'" style="color:#409EFF;font-weight:bold;">⓵</span>
                <span v-else-if="row.deep_coversion_worth_goal_cn === '七日变现ROI'" style="color:#67C23A;font-weight:bold;">⑦</span>
                <span v-else>{{ row.deep_coversion_worth_goal_cn || '' }}</span>
              </span>
            </template>
          </el-table-column>

          <!-- 总消耗列 -->
          <el-table-column
              prop="totalCost"
              label="总消耗"
              min-width="90"
          >
            <template slot-scope="{row}">
              <span v-if="row.gameName!=='汇总数据'">{{ getTotalCost(row) }}</span>
              <span v-else>{{ row.totalCost ? row.totalCost.toFixed(2) : '0.00' }}</span>
            </template>
          </el-table-column>

          <!-- 首小时/2/3/8小时ROI和倍率（合并列） -->
          <el-table-column label="首小时" min-width="90" sortable sort-by="roi1h">
            <template slot-scope="{row}">
              <div style="font-size: 11px; white-space: nowrap;">
                <span :style="getNewRoiStyle(row.isLower1h)">{{ formatNumber(row.roi1h) }}</span>
                <span style="color: #C0C4CC;">/</span>
                <span :style="getNewBlStyle(row.bl1h)">{{ formatNumber(row.bl1h) }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="2小时" min-width="90" sortable sort-by="roi2h">
            <template slot-scope="{row}">
              <div style="font-size: 11px; white-space: nowrap;">
                <span :style="getNewRoiStyle(row.isLower2h)">{{ formatNumber(row.roi2h) }}</span>
                <span style="color: #C0C4CC;">/</span>
                <span :style="getNewBlStyle(row.bl2h)">{{ formatNumber(row.bl2h) }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="3小时" min-width="90" sortable sort-by="roi3h">
            <template slot-scope="{row}">
              <div style="font-size: 11px; white-space: nowrap;">
                <span :style="getNewRoiStyle(row.isLower3h)">{{ formatNumber(row.roi3h) }}</span>
                <span style="color: #C0C4CC;">/</span>
                <span :style="getNewBlStyle(row.bl3h)">{{ formatNumber(row.bl3h) }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="8小时" min-width="90" sortable sort-by="roi8h">
            <template slot-scope="{row}">
              <div style="font-size: 11px; white-space: nowrap;">
                <span :style="getNewRoiStyle(row.isLower8h)">{{ formatNumber(row.roi8h) }}</span>
                <span style="color: #C0C4CC;">/</span>
                <span :style="getNewBlStyle(row.bl8h)">{{ formatNumber(row.bl8h) }}</span>
              </div>
            </template>
          </el-table-column>

          <!-- 小时列 -->
          <template v-for="(hourCol, index) in hourColumns">
            <el-table-column
                :key="`hour-${index}`"
                :prop="hourCol.prop"
                :label="hourCol.label"
                min-width="99"
                show-overflow-tooltip
            >
              <template slot-scope="{row}">
                <div style="font-size: 11px; line-height: 1.4;">
                  <!-- 汇总行显示 -->
                  <template v-if="row.gameName === '汇总数据'">
                    <div>{{ formatNumber(getHourValue(row, hourCol.prop, 'statCostAllX')) }}</div>
                    <div style="color: #909399;">
                      {{ formatNumber(getHourValue(row, hourCol.prop, 'nowRoi')) }}/{{ formatNumber(getHourValue(row, hourCol.prop, 'nowBl')) }}
                    </div>
                  </template>

                  <!-- 普通行显示 -->
                  <template v-else>
                    <div>{{ formatNumber(getHourStatCost(row, hourCol.label).statCost) }}</div>
                    <div style="color: #909399;">
                      <span :style="getNowRoiStyle(row, hourCol.label)">{{ formatNumber(getHourStatCost(row, hourCol.label).nowRoi) }}</span>
                      /<span :style="getNowBlStyle(row, hourCol.label)">{{ formatNumber(getHourStatCost(row, hourCol.label).nowBl) }}</span>
                    </div>
                  </template>
                </div>
              </template>
            </el-table-column>
          </template>

        </el-table>

        <div class="block">

          <el-pagination
              @current-change="search(true)"
              :current-page.sync="currentPage"
              :page-sizes="[25]"
              :page-size="100"
              layout="total, sizes, prev, pager, next, jumper"
              :total="size">
          </el-pagination>
        </div>
      </div>

      <el-dialog :visible.sync="dialogTableVisible" width="78%"
                 :title="title"
      >
        <el-table :data="gridData"
                  max-height="75vh"
                  height="74vh"
                  size="mini"
                  stripe
        >
          <el-table-column property="dateHour" label="时间点" sortable width="200" align="center">
          </el-table-column>
          <el-table-column property="hourDelay" label="经过小时" sortable width="110" align="center"></el-table-column>
          <el-table-column property="sevenBl" label="当日(游戏维度)倍率" width="180" align="center"></el-table-column>
          <el-table-column property="nowBl" label="该时间段倍率" width="180" align="center"></el-table-column>
          <el-table-column property="upBl" label="提升比例" width="180" align="center">

            <template slot-scope="{row}">
              <span style="color: #d65055"
                    v-if="row.upBl/row.incomeRatio>0"> {{ row.upBl / row.incomeRatio|dataFilters2 }}</span>

              <span style="color: #5daf34" v-else>{{ row.upBl / row.incomeRatio|dataFilters2 }}</span>
            </template>

          </el-table-column>
          <el-table-column property="sevenRoi" label="当日(游戏维度)ROI" width="180" align="center"></el-table-column>
          <el-table-column property="nowRoi" label="该时间ROI" width="150" align="center"></el-table-column>
          <el-table-column property="upRoi" label="提升比例" width="150" align="center">
            <template slot-scope="{row}">

              <span style="color: #d65055"
                    v-if="row.upRoi/row.statCostRatio>0">  {{ row.upRoi / row.statCostRatio|dataFilters2 }}</span>

              <span style="color: #5daf34" v-else>  {{ row.upRoi / row.statCostRatio|dataFilters2 }}</span>
            </template>

          </el-table-column>
          <el-table-column property="statCost" label="消耗" sortable width="100" align="center"></el-table-column>
          <el-table-column property="statCostRatio" label="消耗占比" width="150" align="center">

          </el-table-column>
          <el-table-column property="firstHourIncome" label="首小时收入" sortable width="150"
                           align="center"></el-table-column>
          <el-table-column property="incomeRatio" label="收入占比" width="150" align="center">

          </el-table-column>
        </el-table>
      </el-dialog>

      <el-dialog :visible.sync="dialogTableVisible3" width="78%"
                 :title="title"
      >

        <div ref="lineChart" style="width: 100%; height: 400px; margin-bottom: 20px"></div>

        <el-table :data="tableHour"
                  max-height="75vh"
                  height="74vh"
                  size="mini"
                  stripe
        >

          <el-table-column property="dateDelay" label="经过小时" sortable width="110" align="center"></el-table-column>
          <el-table-column property="statCost" label="素材消耗" width="180" align="center"></el-table-column>
          <el-table-column property="statAttributionMicroGame24HAmount" label="收入" width="180"
                           align="center"></el-table-column>
          <el-table-column property="costRatio" label="消耗占比" width="180" align="center"></el-table-column>
          <el-table-column property="dailyTotalCost" label="当日总消耗" width="180" align="center"></el-table-column>
          <el-table-column property="dailyTotalCost" label="ROI" width="180" align="center">
            <template slot-scope="{row}">
              {{ (row.statAttributionMicroGame24HAmount / row.statCost * 100).toFixed(2) + '%' }}

            </template>

          </el-table-column>

        </el-table>


      </el-dialog>
    </el-container>

  </div>
</template>

<script>import Bl from '../抖音/Bl.vue';
import { getFavorites, addFavorite, removeFavorite } from '@/utils/favoriteUtils';

export default {
  name: "GameWx3V1",
  // components: {
  //   Bl
  // },
  data() {

    return {
      currentDate: this.getCurrentDate(),
      // 控制小时列显示内容的选项
      hourDisplayOptions: [
        {label: '倍率(nowBl)', value: 'nowBl', checked: true},
        {label: 'ROI(nowRoi)', value: 'nowRoi', checked: true},
          {label: '首小时Roi', value: 'firstHourIncome', checked: true},
      ],
// 当前选中的显示项
      selectedHourDisplays: ['nowBl', 'nowRoi'],
      dialogChartVisible: false,  // 添加图表弹窗可见性控制
      chartDialogTitle: "小时数据图表",  // 图表弹窗标题
      value6: '',  // 将在setToCurrentHourPoint中初始化
      showBlChart: false,
      hourColumns: [],
      myChartData: [],
      valueProm: '',
      favorites: [],
      totalData: [],
      showT: true,
      dialogTableVisible3: false,
      showColumnSetting: false,
      columnOptions: [
        {prop: 'gameName', label: '游戏名'},
        {prop: 'statHour', label: '时间'},
        {prop: 'promotionId', label: '广告ID'},
        {prop: 'materialId', label: '素材ID'},
        {prop: 'click', label: '操作'},
        {prop: 'tfPerson', label: '投放人员'},
        {prop: 'statCost', label: '消耗'},
        {prop: 'ljBl', label: '环比前一日(消耗)'},
        {prop: 'sumRoi', label: 'ROI'},
        {prop: 'statCostY', label: '环比前一日(ROI)'},
        {prop: 'f1HAmount', label: '时速'},
        {prop: 'getType', label: '投放方式'},
        {prop: 'getPrice', label: '出价'},
        {prop: 'today24Roi', label: '今日素材预估24小时ROI（此点消耗）'},
        {prop: 'compare3', label: '精确对比'},
        {prop: 'yesterday24Roi', label: '昨日素材预估24小时ROI（此点消耗）'},
        {prop: 'today24RoiGame', label: '今日游戏预估24小时ROI（此点消耗）'},
        {prop: 'yesterday24RoiGame', label: '昨日游戏预估24小时ROI（此点消耗）'},
        {prop: 'seven24RoiNow', label: '前七日游戏实际24小时ROI(此点消耗)'},
        {prop: 'today24Bl', label: '今日素材预估24小时倍率(此点消耗)'},
        {prop: 'compare1', label: '精确对比'},
        {prop: 'yesterday24Bl', label: '昨日素材预估24小时倍率（此点消耗）'},
        {prop: 'today24BlGame', label: '今日游戏预估24小时倍率(此点消耗)'},
        {prop: 'yesterday24BlGame', label: '昨日游戏预估24小时倍率(此点消耗)'},
        {prop: 'seven24BlNow', label: '前七日游戏实际24小时倍率(此点消耗)'},
        {prop: 'yesterdayRoiYg', label: '昨日素材预估24小时ROI（24小时消耗）'},
        {prop: 'compare4', label: '精确对比'},
        {prop: 'yg24GameRoi', label: '昨日游戏预估24小时ROI（24小时消耗）'},
        {prop: 'seven24Roi', label: '前七日游戏实际24小时ROI'},
        {prop: 'yesterdayBlYg', label: '昨日素材预估24小时倍率（24小时消耗）'},
        {prop: 'compare2', label: '精确对比'},
        {prop: 'yg24GameBl', label: '昨日游戏预估24小时倍率(24小时消耗)'},
        {prop: 'seven24Bl', label: '前七日游戏实际24小时倍率(24小时消耗)'}

        // 添加所有需要控制的列配置...
      ],
      colOptions: ['gameName', 'statHour', 'promotionId', 'promotionId', 'materialId',
        'click', 'tfPerson', 'statCost', 'ljBl', 'sumRoi', 'statCostY', 'f1HAmount', 'getType',
        'getPrice', 'today24Roi', 'compare3', 'yesterday24Roi', 'today24RoiGame',
        'yesterday24RoiGame', 'seven24RoiNow', 'today24Bl', 'compare1', 'yesterday24Bl', 'today24BlGame', 'yesterday24BlGame', 'seven24BlNow'
        , 'yesterdayRoiYg', 'compare4', 'yg24GameRoi', 'seven24Roi', 'yesterdayBlYg', 'compare2', 'yg24GameBl', 'seven24Bl'], // 默认显示的列
      title: "",
      gridData: [],
      dialogTableVisible: false,
      size: 1,
      isSort: true,
      echartShow: false,
      options2: ['+', '-', '*', '/'],
      newProp: '例如(进入游戏)',
      newPropValue: '',
      valProp2: '',
      valueSuan: '',
      colData: [{title: "账面消耗", istrue: true},
        {title: "实际消耗", istrue: false},
      ],

      valProp: '例如(1,下一关)',
      titleHeads: [{sta_value: "进入游戏", sta_view_value: "进入游戏"}, {
        sta_value: "下一关",
        sta_view_value: "进入下一关"
      }],
      list: [],
      srcProm: '',
      titleProm: "",
      value1: '',
      currentPage: 1,
      loading: false,

      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      }, pickerOptions3: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }, pickerOptions2: {
        disabledDate(date) {
          return date.getTime() >= Date.now() - 8.64e7;  //只能选择今天及今天之后的日期，如果没有后面的-8.64e7就是今天也不能选
        }
      },
      tableData: [],
      tableData2: [],
      optionsGame: [],
      valueGame: "",
      value: 0,
      tableKey: 0,
      ecpmA: 300,
      value2: '',
      value3: 7
      , json_data: []
      , json_fields: {},
      height: 800,
      dialogTableVisible2: false,
      arr1: [],
      arr2: [],
      valueGame2: '',
      expandedRows: [],
      items: [],
      person: "",
      maxHeight: 800,
      selectedField: 'statCost',
      selectedField2: 'statCost',
      selectText: "",
      chartData: [], // 这里放入你的原始数据
      chartData2: [],
      chartInstance: null,
      chartInstance2: null,
      chartInstance3: null,
      tableHour: [],
      valueAccount: "",
      chartLoading: false,
      originalData: [], // 存储原始数据行
      summaryRow: null, // 单独存储汇总行
      summaryRowIndex: 0,
      statusCache: {},
      mylogData:[],
      currentRowData:{}
    }


  }, watch: {
    colOptions: {
      handler(newVal) {
        localStorage.setItem('columnSettings', JSON.stringify(newVal));
      },
      deep: true
    }

  }, filters: {
    dataFilters(value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return "-"

      } else if (value < 100) {

        return value

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }

    }, dataFilters2(value) {
      // 截取当前数据到小数点后两位
      // 截取当前数据到小数点后两位
      if (value == 0 || isNaN(value)) {

        return "-"
      } else {
        value = (value * 100).toFixed(2) + '%'
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }

    }
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.dispose()
    }
    if (this.chartInstance2) {
      this.chartInstance2.dispose()
    }
    if (this.chartInstance3) {
      this.chartInstance3.dispose()
    }
  }, created() {
    // 从localStorage加载保存的列设置
    const savedColumns = localStorage.getItem('columnSettings');
    this.colOptions = savedColumns ? JSON.parse(savedColumns) :
        this.columnOptions.map(col => col.prop);
  }, computed: {
    // 动态组合数据，确保汇总行始终在顶部
    displayData() {
      if (this.summaryRow) {
        return [this.summaryRow, ...this.originalData];
      }
      return this.originalData;
    }
  },
  methods: {
    switchDay(offset) {
      const date = new Date(this.currentDate);
      date.setDate(date.getDate() + offset); // 根据偏移量调整日期

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      this.currentDate = `${year}-${month}-${day}`; // 更新当前日期

      // 重新加载图表数据
      this.loadChartData();
    },
    loadChartData() {
      // 检查是否正在加载，防止重复点击
      if (this.chartLoading) {
        return;
      }

      // 设置加载状态
      this.chartLoading = true;

      this.$axios
          .get('/tf3/data/findHourMaterialAll?materialId=' + this.currentRowData.materialId
              + '&promotionId=' + this.currentRowData.promotionId +
              '&hour=' + this.currentDate, {})
          .then(successResponse => {
            this.myChartData = successResponse.data.data || []

            console.log("=======成功加载数据")

            this.$axios.post('/toufangWx/data/findAutolog', {

              date: this.currentDate,
              promontionId: this.currentRowData.promotionId,
              accountId: this.currentRowData.accountId,

            }).then(successResponse => {

              this.mylogData = successResponse.data.data || []

              this.$axios
                  .get('/tf3/data/findHourCostRoi?promotionId=' + this.currentRowData.promotionId + '&materialId=' + this.currentRowData.materialId+ '&uploadTime=' +this.currentDate
                      , {})
                  .then(successResponse => {

                    this.chartData = successResponse.data.data
                    // 确保数据加载完成后再初始化图表
                    this.$nextTick(() => {
                      this.initChart();

                    });

                  })
            })
                .finally(() => {
                  // 无论成功或失败都重置加载状态
                  this.chartLoading = false;
                });
          })
    },

    getCurrentDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    async fetchStatusForItems() {
      this.statusCache = {};
      const promises = this.tableData.map(async (item) => {
        const key = `${item.accountId}-${item.materialId}`;

        // 如果已经缓存过状态，则直接使用缓存
        if (this.statusCache[key]) {
          item.status = this.statusCache[key].system_status_cn;
          return;
        }

        try {
          const response = await this.$axios.post('/toufangWx/data/findStatus', {
            accountId: item.accountId,
            materialId: item.materialId,
            promotionId:''
          });

          const status = response.data.data.system_status_cn || '未知'; // 假设接口返回 status 字段
          this.statusCache[key] = response.data.data; // 缓存状态
          // item.status = status;
          this.$set(item, 'status', status); // 使用 $set 确保响应式更新
          this.$set(item, 'acquisitionCost', response.data.data.acquisition_cost); // 使用 $set 确保响应式更新

          this.$set(item, 'cost', response.data.data.cost);
          this.$set(item, 'mini_game_income_roi_1', response.data.data.mini_game_income_roi_1);

        } catch (error) {
          console.error(`查询状态失败: ${key}`, error);
          item.status = '查询失败'; // 设置默认值
        }
      });

      await Promise.all(promises); // 等待所有请求完成
    },

    async fetchAutoStatusForItems() {

      // 1. 先对 tableData 按 promotionId 去重
      const uniquePromotions = Array.from(
          new Map(this.tableData.map(item => [item.promotionId, item])).values()
      );
      // 1. 直接遍历 tableData，为每个 promotionId 获取对应的 accountId
      const requests = uniquePromotions.map(item => ({
        accountId: item.accountId,
        promotionId: item.promotionId
      }));

      // 2. 对每个 promotionId 单独发起请求
      const promises = requests.map(async ({ accountId, promotionId }) => {
        try {
          const response = await this.$axios.post('/toufangWx/data/findAutoStatus', {
            accountId: accountId, // 使用对应的 accountId
            materialId: '', // 如果不需要 materialId 可以留空
            promotionIds: [promotionId] // 每次只传一个 promotionId
          });

          // 假设接口返回的是一个数组，包含每个 promotionId 的状态
          const statusList = response.data.data || [];

          // 更新 tableData 中对应项的状态
          this.tableData.forEach(row => {
            const statusItem = statusList.find(
                item => item.adgroup.adgroup_id + '' === row.promotionId
            );

            if (statusItem) {
              console.log("=========有匹配的");
              this.$set(row, 'autoStatus', statusItem.adgroup.auto_acquisition_status_text || '未知');
              this.$set(row, 'auto_acquisition_status_message', statusItem.adgroup.auto_acquisition_status_message || '');
              this.$set(row, 'auto_acquisition_budget', statusItem.adgroup.auto_acquisition_budget || 0);
              this.$set(row, 'deep_coversion_worth_goal_cn',statusItem.adgroup.deep_coversion_worth_goal_cn||''); // 使用 $set 确保响应式更新
              this.$set(row, 'deep_conversion_worth_rate',statusItem.adgroup.deep_conversion_worth_rate||''); // 使用 $set 确保响应式更新

              this.$set(row, 'income_roi_1_24h_pla',statusItem.report.income_roi_1_24h_pla||''); // 使用 $set 确保响应式更新
            }
          });
        } catch (error) {
          console.error(`查询状态失败: accountId=${accountId}, promotionId=${promotionId}`, error);
          // 设置默认值
          const item = this.tableData.find(row => row.promotionId === promotionId);
          if (item) {
            this.$set(item, 'autoStatus', '查询失败');
          }
        }
      });

      await Promise.all(promises); // 等待所有请求完成

      console.log("=====table", this.tableData);
    },
    getHourDataValue(row, hourCol) {
      if (row.gameName === '汇总数据') {
        const hourData = row[hourCol.prop];
        if (hourData && typeof hourData === 'object' && hourData.nowBl !== undefined) {
          return hourData.nowBl;
        }
        return hourData || '-';
      }
      return row[hourCol.prop] || '-';
    },
    // 获取汇总行小时数据字段值
    getHourValue(row, prop, field) {
      const hourData = row[prop];
      if (hourData && typeof hourData === 'object' && hourData[field] !== undefined && hourData[field] !== null) {
        return hourData[field];
      }
      return '-';
    },
    // 格式化数字显示（保留2位小数）
    formatNumber(val) {
      if (val === null || val === undefined || val === '-') {
        return '-';
      }
      const num = parseFloat(val);
      if (isNaN(num)) {
        return '-';
      }
      return num.toFixed(2);
    },
    toSummaryNumber(val) {
      if (val === null || val === undefined || val === '-' || val === '') {
        return 0;
      }
      const num = parseFloat(val);
      return isNaN(num) ? 0 : num;
    },
    getSummaryRoi(row) {
      const cost = this.toSummaryNumber(row.totalCost || row.statCost || row.cost);
      const income = this.toSummaryNumber(
          row.totalIncome !== undefined && row.totalIncome !== null ? row.totalIncome : row.totalInCome
      );
      if (cost <= 0 || income <= 0) {
        return '-';
      }
      return (income / cost).toFixed(2);
    },
    normalizeSummaryRow(summaryRow, rows) {
      const list = Array.isArray(rows) ? rows : [];
      const row = summaryRow && Object.keys(summaryRow).length > 0
          ? {...summaryRow}
          : {gameName: '汇总数据'};

      if (!row.gameName) {
        row.gameName = '汇总数据';
      }

      const totalCost = this.sumSummaryField(list, ['totalCost', 'statCost', 'cost']);
      let totalIncome = this.sumSummaryField(list, ['totalIncome', 'totalInCome']);
      if (totalIncome <= 0) {
        totalIncome = list.reduce((sum, item) => {
          const itemCost = this.firstSummaryNumber(item, ['totalCost', 'statCost', 'cost']);
          const roi = this.firstSummaryNumber(item, ['mini_game_income_roi_1', 'totalRoi', 'sumRoi']);
          return itemCost > 0 && roi > 0 ? sum + itemCost * roi : sum;
        }, 0);
      }

      if (this.toSummaryNumber(row.totalCost) <= 0 && totalCost > 0) {
        row.totalCost = totalCost;
      }
      if (this.toSummaryNumber(row.totalIncome) <= 0 && totalIncome > 0) {
        row.totalIncome = totalIncome;
      }
      if (this.toSummaryNumber(row.totalInCome) <= 0 && totalIncome > 0) {
        row.totalInCome = totalIncome;
      }

      const finalCost = this.toSummaryNumber(row.totalCost);
      const finalIncome = this.toSummaryNumber(row.totalIncome || row.totalInCome);
      if (finalCost > 0) {
        row.statCost = finalCost;
        row.cost = finalCost;
      }
      if (finalCost > 0 && finalIncome > 0) {
        const roi = finalIncome / finalCost;
        row.sumRoi = roi;
        row.mini_game_income_roi_1 = roi;
      }

      const firstIncome = this.fillSummaryPeriod(row, list, '1h', 0);
      this.fillSummaryPeriod(row, list, '2h', firstIncome);
      this.fillSummaryPeriod(row, list, '3h', firstIncome);
      this.fillSummaryPeriod(row, list, '8h', firstIncome);

      return row;
    },
    firstSummaryNumber(row, fields) {
      for (const field of fields) {
        const value = this.toSummaryNumber(row[field]);
        if (value > 0) {
          return value;
        }
      }
      return 0;
    },
    sumSummaryField(rows, fields) {
      return rows.reduce((sum, row) => sum + this.firstSummaryNumber(row, fields), 0);
    },
    fillSummaryPeriod(summaryRow, rows, suffix, baseIncome) {
      const costKey = `cost${suffix}`;
      const incomeKey = `income${suffix}`;
      const roiKey = `roi${suffix}`;
      const blKey = `bl${suffix}`;
      const lowerKey = `isLower${suffix}`;

      let cost = this.toSummaryNumber(summaryRow[costKey]);
      let income = this.toSummaryNumber(summaryRow[incomeKey]);

      if (cost <= 0) {
        cost = this.sumSummaryField(rows, [costKey]);
      }
      if (income <= 0) {
        income = rows.reduce((sum, row) => {
          const itemIncome = this.toSummaryNumber(row[incomeKey]);
          if (itemIncome > 0) {
            return sum + itemIncome;
          }
          const itemCost = this.toSummaryNumber(row[costKey]);
          const itemRoi = this.toSummaryNumber(row[roiKey]);
          return itemCost > 0 && itemRoi > 0 ? sum + itemCost * itemRoi : sum;
        }, 0);
      }

      if (cost > 0) {
        summaryRow[costKey] = cost;
      }
      if (income > 0) {
        summaryRow[incomeKey] = income;
      }
      if (cost > 0 && income > 0) {
        summaryRow[roiKey] = income / cost;
      }
      if (suffix === '1h') {
        summaryRow[blKey] = income > 0 ? 1 : 0;
      } else if (baseIncome > 0 && income > 0) {
        summaryRow[blKey] = income / baseIncome;
      }
      if (summaryRow[lowerKey] === undefined || summaryRow[lowerKey] === null) {
        summaryRow[lowerKey] = false;
      }

      return income;
    },
    // 计算ROI进度条颜色（根据ROI值大小显示不同颜色）
    getRoiBarColor(val) {
      if (val === null || val === undefined || val === '-' || val === '') {
        return '#c0c4cc';
      }
      const num = parseFloat(val);
      if (isNaN(num)) {
        return '#c0c4cc';
      }
      if (num < 0.5) {
        return '#f56c6c';
      }
      if (num < 1.0) {
        return '#e6a23c';
      }
      return '#67c23a';
    },
    // 根据ROI值返回简约图标
    getRoiIcon(val) {
      if (val === null || val === undefined || val === '-' || val === '') {
        return '○';
      }
      const num = parseFloat(val);
      if (isNaN(num)) {
        return '○';
      }
      if (num < 0.5) {
        return '○';
      }
      if (num < 1.0) {
        return '◑';
      }
      return '●';
    },
    // 格式化短数字（用于小时列，更紧凑）
    formatShortNumber(val) {
      if (val === null || val === undefined || val === '-') {
        return '-';
      }
      const num = parseFloat(val);
      if (isNaN(num)) {
        return '-';
      }
      // 小于1000直接显示，大于1000显示为k
      if (Math.abs(num) < 1000) {
        return num.toFixed(num % 1 === 0 ? 0 : 1);
      } else if (Math.abs(num) < 10000) {
        return (num / 1000).toFixed(1) + 'k';
      } else {
        return (num / 1000).toFixed(0) + 'k';
      }
    },
    // 处理小时列显示选项变化
    handleHourDisplayChange(values) {
      this.selectedHourDisplays = values || [];
      // 保存用户选择到本地存储
      localStorage.setItem('hourDisplayOptions', JSON.stringify(this.selectedHourDisplays));
    },

// 从本地存储加载小时列显示设置
    loadHourDisplaySettings() {
      const savedSettings = localStorage.getItem('hourDisplayOptions');
      if (savedSettings) {
        try {
          this.selectedHourDisplays = JSON.parse(savedSettings);
        } catch (e) {
          console.error('加载小时列显示设置失败:', e);
        }
      }
    },
    // 在表格行上添加特殊类名
    tableRowClassName({row, rowIndex}) {
      // 如果是汇总行，添加特殊类名
      if (row.gameName === '汇总数据') {
        return 'summary-row';
      }

      // 原有的行类名逻辑
      if (rowIndex % 6 == 0) {
        return 'column-style2';
      } else {
        return 'column-style2';
      }
    },
    getCurrentHourPoint() {
      const now = new Date();
      const minutes = now.getMinutes();

      if (minutes >= 50) {
        // 如果分钟数大于等于50，则使用当前小时
        now.setMinutes(0, 0, 0); // 设置为整点
      } else {
        // 如果分钟数小于50，则使用前一小时
        now.setHours(now.getHours() - 1);
        now.setMinutes(0, 0, 0); // 设置为前一小时的整点
      }

      // 格式化为 yyyy-MM-dd HH:00:00 格式
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hour = String(now.getHours()).padStart(2, '0');

      return `${year}-${month}-${day} ${hour}:00:00`;
    },

    setToCurrentHourPoint() {
      this.value6 = this.getCurrentHourPoint();
      this.value1 = this.getCurrentHourPoint();
      this.search(true); // 自动刷新数据
    },
// 计算当天0-23小时的总消耗
    getTotalCost(row) {
      if (!row.dataDetail || !Array.isArray(row.dataDetail)) {
        return 0;
      }


      // 筛选当天的数据并计算总消耗
      const dailyData = row.dataDetail.filter(item => {
        return item.dateHour.startsWith(this.value1.split(' ')[0]);
      });

      // 计算总消耗
      const totalCost = dailyData.reduce((sum, item) => {
        const cost = parseFloat(item.statCost) || 0;
        return sum + cost;
      }, 0);

      return totalCost.toFixed(2);
    },
    // 切换展开状态
    toggleExpand(rowIndex) {
      const index = this.expandedRows.indexOf(rowIndex);
      if (index > -1) {
        this.expandedRows.splice(index, 1);
      } else {
        this.expandedRows.push(rowIndex);
      }
    },

    // 处理展开状态变化
    handleExpandChange(row, expanded) {
      const rowIndex = this.totalData.indexOf(row);
      if (expanded) {
        if (!this.expandedRows.includes(rowIndex)) {
          this.expandedRows.push(rowIndex);
        }
      } else {
        const index = this.expandedRows.indexOf(rowIndex);
        if (index > -1) {
          this.expandedRows.splice(index, 1);
        }
      }
    },
    chartOpen(row) {

    },updateChart() {
      // 生成 0-23 小时的时间数组
      const hours = Array.from({ length: 24 }, (_, i) => i);

// 初始化数据数组，填充 null
      const statCostData = new Array(24).fill(null);
      const sumRoiData = new Array(24).fill(null);
      const statCostData2 = new Array(24).fill(null);
      const sumRoiData2 = new Array(24).fill(null);
      const priceData = new Array(24).fill(null);
      const acquisitionCostData = new Array(24).fill(null);


// 遍历 chartData 和 myChartData，根据时间匹配数据
      this.chartData.forEach(item => {
        const hour = parseInt(item.uploadTime.split(' ')[1].split(':')[0]); // 提取小时
        if (hours.includes(hour)) {
          statCostData[hour] = item.statCost;
          sumRoiData[hour] = item.sumRoi;
          priceData[hour] = item.wxPrice?.deepConversionWorthRate || 0;
        }
      });

      this.myChartData.forEach(item => {
        const hour = parseInt(item.stat_time_hour.split(' ')[1].split(':')[0]); // 提取小时
        if (hours.includes(hour)) {
          statCostData2[hour] = item.max_stat_cost;
          sumRoiData2[hour] = item.roi_value.toFixed(2);
          acquisitionCostData[hour] = item.max_acquisition_cost;
        }
      });
      const autologistData = new Array(24).fill(null).map(() => ({ time: null }));

      this.mylogData.filter(item => item.operation_log[0].after === '开启').forEach(item => {
        const hour = parseInt(item.created_time.split(' ')[1].split(':')[0]); // 提取小时
        if (hours.includes(hour)) {
          autologistData[hour] = item.created_time.split(' ')[1].split(':')[1]+'.'+item.created_time.split(' ')[1].split(':')[2]; // 存储完整的时间信息
        }
      });

      const autologistData2 = new Array(24).fill(null).map(() => ({ time: null }));

      this.mylogData.filter(item => item.operation_log[0].after === '关闭').forEach(item => {
        const hour = parseInt(item.created_time.split(' ')[1].split(':')[0]); // 提取小时
        if (hours.includes(hour)) {
          autologistData2[hour] = item.created_time.split(' ')[1].split(':')[1]+'.'+item.created_time.split(' ')[1].split(':')[2]; // 存储完整的时间信息
        }
      });


      const option = {

        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: hours,
          name: '时间'
        },
        legend: {
          type: 'scroll', // 启用滚动模式
          orient: 'horizontal', // 水平排列
          left: 'center',
          bottom: '',
          data: ['一键起量消耗','整点消耗', '时段消耗', '整点ROI', '时段ROI','出价', '开启标记','关闭标记'],
          selected: {'整点消耗':false,'出价': false},
          formatter: (name) => {
            // 自定义图例名称显示
            if (name === '开启标记') {
              return '开启标记';
            }
            return name;
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '消耗',
            position: 'left',
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            name: 'ROI',
            position: 'right',
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            name: '标记值', // 第三个 y 轴名称
            position: 'right', // 可以调整位置，例如 'left' 或 'right'
            offset: 50, // 偏移量，避免与第二个 y 轴重叠
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        grid: {
          left: '1%',
          bottom: '2%',
          top: '15%',
          right: '4%',
          containLabel: true
        },
        series: [
          {
            name: '整点消耗',
            type: 'bar',
            yAxisIndex: 0,
            data: statCostData,
            itemStyle: {
              color: '#206727' // 内层颜色
            }
          },


          {
            name: '时段消耗',
            type: 'bar',

            barGap: '-100%',
            yAxisIndex: 0, // 绑定到左侧 Y 轴
            data: statCostData2,
            itemStyle: {
              color: '#2686cb' // 柱状图颜色
            }
          },   {
            name: '一键起量消耗',
            type: 'bar',

            barGap: '-100%',
            yAxisIndex: 0,
            data: acquisitionCostData,
            itemStyle: {
              color: '#a65050' // 外层颜色
            }
          },
          {
            name: '整点ROI',
            type: 'line',
            yAxisIndex: 1, // 绑定到右侧 Y 轴
            data: sumRoiData,
            smooth: true,
            lineStyle: {
              color: '#E6A23C' // 曲线颜色
            },
            itemStyle: {
              color: '#E6A23C'
            }
          },{
            name: '时段ROI',
            type: 'line',
            yAxisIndex: 1, // 绑定到右侧 Y 轴
            data: sumRoiData2,
            smooth: true,
            lineStyle: {
              color: '#bb4c39' // 曲线颜色
            },
            itemStyle: {
              color: '#bb4c39'
            }
          },
          {
            name: '出价',
            type: 'line',
            yAxisIndex: 1, // 绑定到右侧 Y 轴
            data: priceData,
            smooth: true,
            lineStyle: {
              color: '#909399', // 出价曲线颜色
              type: 'dashed' // 虚线样式
            },
            itemStyle: {
              color: '#909399'
            }
          },{
            name: '开启标记',
            type: 'scatter',
            yAxisIndex: 2,
            symbol: 'triangle', // 标记形状
            symbolSize: 10, // 标记大小
            itemStyle: {
              borderWidth: 3,
              borderColor: '#EE6666',
              color: 'yellow'
            },
            data: autologistData,


          },{
            name: '关闭标记',
            type: 'scatter',
            symbol: 'rect', // 标记形状
            symbolSize: 10, // 标记大小
            itemStyle: {
              borderWidth: 3,
              borderColor: '#EE6666',
              color: '#e7a1a1'
            },
            data: autologistData2


          }
        ]
      };

      this.chartInstance.setOption(option);

      // 窗口变化自适应
      window.addEventListener('resize', () => {
        this.chartInstance.resize();
      });
    },

    // 生成小时列配置
    generateHourColumns() {


      const hours = [];
      for (let i = 0; i <= 23; i++) {  // 0-23小时
        hours.push({
          prop: `hour_${i}`,
          label: `${i}:00`,
          minWidth: 110
        });
      }
      return hours;
    },

    // 刷新表格的方法
    refreshTable() {
      this.tableKey += 1; // 改变 key 值，强制组件重新渲染
    },
    // 在 sortMethod 方法中
    sortMethod(column, prop, order) {
      this.loading = true
      console.log(column.order === null)
      console.log(column.prop)
      if (column.order === null)
        column.order = "descending"

      // 确保value6有有效值
      const incomeTime = this.value6 && this.value6 !== 'today' ? this.value6 : this.value1

      // 【优化】使用一体化查询接口
      this.$axios
          .post('/tf3/data/findWithDetail', {
            gameName: this.valueGame,
            person: this.person == null ? "" : this.person,
            currentPage: this.currentPage,
            uploadTime: this.value1,
            prop: column.prop,
            order: column.order,
            promId: this.valueProm == null ? "" : this.valueProm,
            type: this.showT ? 1 : 0,
            accountId: this.valueAccount == null ? "" : this.valueAccount,
            costTime: this.value1.split(' ')[0],
            incomeTime: incomeTime
          })
          .then(successResponse => {
            // 【优化】直接使用后端返回的数据
            this.tableData = successResponse.data.data.data || []
            this.size = successResponse.data.data.size || 0
            
            // 【优化】汇总行已由后端计算好
            const summaryRow = this.normalizeSummaryRow(successResponse.data.data.summaryRow || null, this.tableData)

            this.fetchStatusForItems()
            this.fetchAutoStatusForItems()
            
            // 【修复】只要有汇总行就显示
            if(summaryRow && Object.keys(summaryRow).length > 0){
              this.totalData = [summaryRow, ...this.tableData]
            } else {
              this.totalData = this.tableData
            }

            console.log("【优化版】排序数据加载完成", this.totalData)

            this.loading = false
            this.$nextTick(() => {
              this.$refs.tableData1.doLayout();
            });
          })
          .catch(error => {
            this.loading = false
            console.error('排序数据加载失败:', error)
            this.$message.error('排序数据加载失败')
          })
    },
    initChart() {
      if (!this.chartData || this.chartData.length === 0) {
        setTimeout(() => {
          this.initChart();
        }, 100); // 延迟 100ms 后重试
        return;
      }

      this.echartShow = true;
      this.chartInstance = this.$echarts.init(this.$refs.chart);
      this.updateChart();
    },
    initChart2() {
      this.echartShow = true

      this.chartInstance2 = this.$echarts.init(this.$refs.chart2)

      this.updateChart2()
    }, initChart3() {

      this.chartInstance3 = this.$echarts.init(this.$refs.lineChart)

      this.updateChart3()
    },

    updateChart2() {
      const xData = this.chartData2.map(item =>
          item.statHour.substring(0, 5)  // 提取时间 HH:mm
      )

      const yData = this.chartData2.map(item => item[this.selectedField2])

      const option = {
        title: {
          text: '时间段趋势分析' + this.selectText
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: xData,
          name: '时间'
        },
        yAxis: {
          type: 'value',
          name: this.selectedLabel
        }, grid: {
          bottom: '2%',
          containLabel: true
        },
        series: [{
          data: yData,
          type: 'line',
          smooth: true,
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {offset: 0, color: 'rgba(58,77,233,0.8)'},
              {offset: 1, color: 'rgba(58,77,233,0.3)'}
            ])
          }
        }]
      }

      this.chartInstance2.setOption(option)

      // 窗口变化自适应
      window.addEventListener('resize', () => {
        this.chartInstance2.resize()
      })
    }, getNowBlStyle(row, hour) {
      const data = this.getHourStatCost(row, hour);

      // 检查值是否为有效数字
      const nowBl = parseFloat(data.nowBl);
      const sevenBl = parseFloat(data.sevenBl);

      if (!isNaN(nowBl) && !isNaN(sevenBl)) {
        if (nowBl < sevenBl) {
          return {
            color: '#d65055', // 红色
            fontWeight: 'bold', // 加粗
            backgroundColor: '#ffebee', // 浅红色背景
            padding: '2px 4px',
            borderRadius: '3px',
            border: '1px solid #ffcdd2',
            position: 'relative',
            cursor: 'help',
            marginLeft: '8px'
          }; // 添加提示样式
        }
      }
      return {color: 'inherit', marginLeft: '8px'};
    }, getNowRoiStyle(row, hour) {
      const data = this.getHourStatCost(row, hour);

      // 检查值是否为有效数字
      const nowBl = parseFloat(data.nowRoi);
      const sevenBl = parseFloat(data.sevenRoi);

      if (!isNaN(nowBl) && !isNaN(sevenBl)) {
        if (nowBl < sevenBl) {
          return {

            color: '#d65055', // 红色
            fontWeight: 'bold', // 加粗
            backgroundColor: '#ffebee', // 浅红色背景
            padding: '2px 4px',
            borderRadius: '3px',
            border: '1px solid #ffcdd2',
            position: 'relative',
            cursor: 'help'
          }; // 添加提示样式
        }
      }
      return {color: 'inherit',};
    },

    // 新字段ROI样式（根据isLower标记显示红色）
    getNewRoiStyle(isLower) {
      if (isLower === 1 || isLower === true) {
        return {
          color: '#d65055',
          fontWeight: 'bold'
        };
      }
      return {color: 'inherit'};
    },

    // 新字段倍率样式
    getNewBlStyle(blValue) {
      const val = parseFloat(blValue);
      if (!isNaN(val) && val < 1) {
        return {
          color: '#d65055',
          fontWeight: 'bold'
        };
      }
      return {color: 'inherit'};
    },

// 添加计算差值的方法
    getNowBlTooltip(row, hour) {
      const data = this.getHourStatCost(row, hour);

      // 检查值是否为有效数字
      const nowBl = parseFloat(data.nowBl);
      const sevenBl = parseFloat(data.sevenBl);

      if (!isNaN(nowBl) && !isNaN(sevenBl)) {
        if (nowBl < sevenBl) {
          const diff = sevenBl - nowBl;
          const percentage = ((diff / sevenBl) * 100).toFixed(2);
          return `比当日平均值低 ${diff.toFixed(2)} (${percentage}%)`;
        } else if (nowBl > sevenBl) {
          const diff = nowBl - sevenBl;
          const percentage = ((diff / sevenBl) * 100).toFixed(2);
          return `比当日平均值高 ${diff.toFixed(2)} (${percentage}%)`;
        }
      }
      return '';
    },
    updateChart3() {

      // 销毁旧的图表实例
      if (this.chartInstance3) {
        this.chartInstance3.dispose()
      }

      // 获取基准值（dateDelay=1时的值）
      const baseValue = this.tableHour.find(item => item.dateDelay === 1)
          ?.statAttributionMicroGame24HAmount || 1

      // 处理图表数据
      const xData = []
      const yData = []
      this.tableHour.forEach(item => {
        xData.push(item.dateDelay)
        yData.push((item.statAttributionMicroGame24HAmount / baseValue).toFixed(2))
      })

      // 初始化图表
      this.chartInstance3 = this.$echarts.init(this.$refs.lineChart)
      const option = {
        title: {
          text: '倍率变化趋势',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          name: '经过小时',
          data: xData
        },
        yAxis: {
          type: 'value',
          name: '收入比值'
        },
        series: [{
          data: yData,
          type: 'line',
          smooth: true,
          lineStyle: {
            color: '#409EFF',
            width: 2
          },
          itemStyle: {
            color: '#409EFF',

          },   // 新增标签配置
          label: {
            show: true,          // 显示标签
            position: 'top',     // 标签位置（可选值：top/right/left/bottom）
            color: '#666',       // 文字颜色
            fontSize: 12,        // 文字大小
            formatter: (params) => {
              // 自定义格式：显示两位小数 + 百分比符号
              return `${(params.value * 1).toFixed(2)}倍`
            }
          }
        }],
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        }
      }
      this.chartInstance3.setOption(option)


    },
// 判断是否为小时列
    isHourColumn(property) {
      // 检查属性是否匹配 hour_0, hour_1, ... hour_23 格式
      return /^hour_\d+$/.test(property);
    },

// 调用 findHourMaterial 方法
    callFindHourMaterial(row, hourLabel) {
      // 将小时标签转换为标准格式，如 "0:00" -> "00:00"


      // 根据当前选择的日期过滤数据
      let targetDate;
      targetDate = this.value1.split(' ')[0]
      const [hour] = hourLabel.split(':');
      const standardHour = hour.padStart(2, '0') + ':00';
      const date = targetDate
      console.log(date)
      this.$axios
          .get('/tf3/data/findHourMaterial?materialId=' + row.materialId
              + '&promotionId=' + row.promotionId +
              '&hour=' + date + ' ' + standardHour, {})
          .then(successResponse => {
            this.tableHour = successResponse.data.data
            this.dialogTableVisible3 = true

            // 在下一个tick初始化图表
            this.$nextTick(() => {
              this.updateChart3()
            })
          })
          .catch(error => {
            console.error('获取小时数据失败:', error);
          });
    },
    // 单机
    contextClick(row, column, cell, event) {

      this.selectText = "（广告ID：" + row.promotionId + " | " + "素材ID：" + row.materialId + "）"

      // 检查是否是小时列（如0:00, 1:00等）
      if (this.isHourColumn(column.property)) {
        // 调用 findHourMaterial 方法
        this.callFindHourMaterial(row, column.label);
      }

      if(column.property === 'shoucang'){


        this.toggleFavorite(row)
      }


      if (column.property === 'gameName') {

        this.chartOpen(row)

      }

      if (column.property === 'statHour') {

        if (row.statHour !== undefined) {

          this.$axios
              .get('/tf3/data/findHourMaterial?materialId=' + row.materialId
                  + '&promotionId=' + row.promotionId +
                  '&hour=' + this.value1.split(' ')[0] + ' ' + row.statHour.substring(0, 5), {})
              .then(successResponse => {

                this.tableHour = successResponse.data.data

                this.dialogTableVisible3 = true

                // 新增：在下一个tick初始化图表
                this.$nextTick(() => {
                  this.updateChart3()
                })
              })

        } else {

          this.$axios
              .get('/tf3/data/findHourMaterialAll?materialId=' + row.materialId
                  + '&promotionId=' + row.promotionId +
                  '&hour=' + this.value1, {})
              .then(successResponse => {
                this.myChartData = successResponse.data.data || []
                console.log(successResponse.data.data)

              })
        }

      }

      console.log(column)

      if (column.property === 'sumRoi'|| column.property === 'statCost' ) {

        if (column.property !== 'gameName' && column.property !== 'tfPerson' && column.property !== 'click') {


          // 检查是否正在加载，防止重复点击
          if (this.chartLoading) {
            return;
          }

          // 设置加载状态
          this.chartLoading = true;
          this.loading=true

          this.currentRowData=row
          this.$axios
              .get('/tf3/data/findHourMaterialAll?materialId=' + row.materialId
                  + '&promotionId=' + row.promotionId +
                  '&hour=' + this.value1, {})
              .then(successResponse => {
                this.myChartData = successResponse.data.data || []


                console.log("=======成功加载数据")

                this.$axios.post('/toufangWx/data/findAutolog', {

                  date: this.value1.split(' ')[0],
                  promontionId: row.promotionId,
                  accountId: row.accountId,

                }).then(successResponse => {

                  this.mylogData = successResponse.data.data || []

                  this.$axios
                      .get('/tf3/data/findHourCostRoi?promotionId=' + row.promotionId + '&materialId=' + row.materialId+ '&uploadTime=' + this.value1.split(' ')[0]
                          , {})
                      .then(successResponse => {

                        this.dialogChartVisible = true;

                        this.selectedField = column.property

                        this.selectedLabel = column.label

                        this.chartData = successResponse.data.data
                        // 确保数据加载完成后再初始化图表
                        this.$nextTick(() => {
                          this.initChart();
                          this.loading=false
                        });

                      })
                })
                    .finally(() => {
                      // 无论成功或失败都重置加载状态
                      this.chartLoading = false;
                    });
                })






        }


      } else if (column.property === 'promotionId') {


        this.titleProm = row.gameName + "（广告ID：" + row.promotionId + " | " + "素材ID：" + row.materialId + "）"
        this.srcProm = "https://ad.qq.com/atlas/" + row.accountId + "/admanage/index?tab=adgroup&query={%22operation_status%22:[%22CALCULATE_STATUS_EXCLUDE_DEL%22],%22system_status%22:[],%22search_name%22:%22" + row.promotionId + "%22}" + "&a=" + Math.random()
        window.open(this.srcProm)
      } else if (column.property === 'materialId') {

        window.open("https://ad.qq.com/atlas/" + row.accountId + "/admanage/index?tab=dynamic_creative&query={%22operation_status%22:[%22CALCULATE_STATUS_EXCLUDE_DEL%22],%22created_time%22:-29,%22fuzzy_name%22:%22" + row.materialId + "%22}")
        // window.open("https://ad.oceanengine.com/material_center/analysis/video/" + row.materialId + "?aadvid=" + row.accountId)

      } else if (column.property === 'accountId') {

        // window.open("https://business.oceanengine.com/site/account-manage/ad/bidding/superior/promotion?keyword=[%22" + row.promotionId + "%22]&searchType=[-1]")
        window.open("https://ad.qq.com/atlas/" + row.accountId + "/admanage/index?tab=adgroup&query={%22operation_status%22:[%22CALCULATE_STATUS_EXCLUDE_DEL%22],%22system_status%22:[]}")

      }
      if (column.property === 'tfPerson') {

        this.title = "广告ID：" + row.promotionId + " | " + "素材ID：" + row.materialId


        this.$axios
            .get('/tf3/data/find4?promotionId=' + row.promotionId + '&materialId=' + row.materialId + '&uploadTime=' + this.value1, {})
            .then(successResponse => {
              this.gridData = successResponse.data.data

              this.dialogTableVisible = true


            })
      }

    }, chartOpen2(row) {
      this.title = "广告ID：" + row.promotionId + " | " + "素材ID：" + row.materialId


      this.$axios
          .get('/tf3/data/find4?promotionId=' + row.promotionId + '&materialId=' + row.materialId + '&uploadTime=' + this.value1, {})
          .then(successResponse => {
            this.gridData = successResponse.data.data

            this.dialogTableVisible = true


          })

    },
    jump(row) {


      window.open("https://ad.qq.com/atlas/" + row.accountId + "/admanage/index?tab=adgroup&query={%22operation_status%22:[%22CALCULATE_STATUS_EXCLUDE_DEL%22],%22system_status%22:[],%22search_name%22:%22" + row.promotionId + "%22}" + "&a=" + Math.random()
      )


    },
    // 双击
    rowClickEvent(row, column, cell, event) {
      console.log(column)
      if (column.property === 'promotionId') {

        // window.open("https://business.oceanengine.com/site/account-manage/ad/bidding/superior/promotion?keyword=[%22" + row.promotionId + "%22]&searchType=[-1]")
        // window.open("https://ad.oceanengine.com/promotion/promote-manage/ad?aadvid=" + row.accountId + "&filter_keyword=%2522" + row.promotionId + "%2522&filter_search_type=%25229%2522" +
        //     "#?drawer_type=ad&drawer_tab=detail&drawer_target_id=" + row.promotionId)


      }

    },
    indexMethod(index) {

      return index / 6 + 1;

    },
    // tableRowClassName({row, rowIndex}) {
    //   if (rowIndex % 6 == 0) {
    //     return 'column-style2';
    //   } else {
    //     return 'column-style2';
    //   }
    // warning-row
    // }
    objectSpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 0 || columnIndex === 1) {
        if (rowIndex % 6 === 0) {
          return {
            rowspan: 6,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },

    // 表头部重新渲染
    renderHeader(h, {column, $index}) {
      // 新建一个 span
      let span = document.createElement('span');
      // 设置表头名称
      span.innerText = column.label;
      // 临时插入 document
      document.body.appendChild(span);
      // 重点：获取 span 最小宽度，设置当前列，注意这里加了 20，字段较多时还是有挤压，且渲染后的 div 内左右 padding 都是 10，所以 +20 。（可能还有边距/边框等值，需要根据实际情况加上）
      column.minWidth = span.getBoundingClientRect().width + 20;
      // 移除 document 中临时的 span
      document.body.removeChild(span);
      return h('span', column.label);

    },
    addProp() {

      this.newPropValue = ''

      if (!this.arr1.includes(this.valProp))
        this.arr1.push(this.valProp + '_')

      if (this.valProp2 != '') {

        this.arr1.push(this.valProp2)
      }
      if (this.valueSuan != '') {

        this.arr2.push(this.valueSuan)

      }


      for (let i = 0; i < this.arr1.length; i++) {
        console.log(this.arr1[i]);

        this.newPropValue = this.newPropValue + this.arr1[i]

        if (this.arr2.length > i)
          this.newPropValue = this.newPropValue + this.arr2[i]

      }


    },
    date_format_new() {

      let date1 = new Date();

      let year = date1.getFullYear();
      // alert(year)
      let month = date1.getMonth() + 1;
      let day = date1.getDate();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;

      this.value2 = year + '' + month + '' + day;


    },

    up(e) {

      if (e == 0) {

        if (this.currentPage > 1)
          this.currentPage--
        this.searchPage()

      } else {

        this.currentPage++

        this.searchPage()
      }


    }, clickTo(row) {

      console.log(row)

    },

    getDiffDay() {
      let totalDays, diffDate
      let myDate_1 = Date.parse(this.value2)
      let myDate_2 = new Date()
      diffDate = Math.abs(myDate_1 - myDate_2)
      totalDays = Math.floor(diffDate / (1000 * 3600 * 24))
      this.value3 = totalDays + 1
    }, value_format3(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0 || isNaN(value)) {

        return "-"
      } else {
        value = value.toFixed(2)

      }
    },
    value_format(row, column, value) {

      console.log(value)
      // 截取当前数据到小数点后两位
      if (value === 0 || isNaN(value) || value * 100 === 0) {

        return "-"
      } else {
        value = (value * 100).toFixed(1) + '%'
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    }, value_format2(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return value == '' ? '-' : value

      } else if (value < 5) {

        return value

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    }, findGame() {

      this.$axios
          .get('/toufangWx/data/findName', {})
          .then(successResponse => {

            this.optionsGame = successResponse.data.data

          })


    }, getHourStatCost(row, hour) {
      if (!row.dataDetail || !Array.isArray(row.dataDetail)) {
        return {
          statCost: '-',
          nowBl: '-',
          sevenBl: '-',
          nowRoi: '-',
          sevenRoi: '-',
          firstHourIncome: '-',
          acquisitionCost:'-'
        };
      }


      // 构造正确的匹配格式：日期 + 时间(补零) + :00(秒)
      const targetDateTime = `${this.value1.split(' ')[0]} ${hour.padStart(5, '0')}:00`;
      const hourData = row.dataDetail.find(item =>
          item.dateHour === targetDateTime
      );

      // 返回包含消耗和倍率的对象
      if (hourData) {
        return {
          statCost: hourData.statCost || '-',
          acquisitionCost: hourData.acquisitionCost || '-',
          nowBl: hourData.nowBl || '-',
          sevenBl: hourData.sevenBl || '-'
          , nowRoi: hourData.nowRoi || '-',
          sevenRoi: hourData.sevenRoi || '-',
          firstHourIncome: hourData.firstHourIncome || '-'
        };
      } else {
        return {
          statCost: '-',
          acquisitionCost: '-',
          nowBl: '-',
          sevenBl: '-',
          nowRoi: '-',
          sevenRoi: '-',
          firstHourIncome: '-'
        };
      }
    },
    async search(flag) {
      if (flag) {
        console.log("手动选条件")
        localStorage.setItem("Game3", JSON.stringify({name: this.valueGame, date: this.value1}))
      } else {
        if (localStorage.getItem("Game3") != null) {
          console.log("自动刷")
          this.valueGame = JSON.parse(localStorage.getItem("Game3")).name
          this.value1 = JSON.parse(localStorage.getItem("Game3")).date
        }
      }

      this.maxHeight = window.innerHeight - 250;

      if (this.value1 !== '') {
        this.loading = true

        // 确保value6有有效值，如果没有则使用value1
        const incomeTime = this.value6 && this.value6 !== 'today' ? this.value6 : this.value1

        try {
          // 【优化】使用一体化查询接口，一次请求获取所有数据（包含小时详情）
          const response = await this.$axios
              .post('/tf3/data/findWithDetail', {
                gameName: this.valueGame,
                person: this.person == null ? "" : this.person,
                currentPage: this.currentPage,
                uploadTime: this.value1,  //消耗时间
                prop: 'statCost',
                order: 'descending',
                promId: this.valueProm == null ? "" : this.valueProm,
                type: this.showT ? 1 : 0,
                accountId: this.valueAccount == null ? "" : this.valueAccount,
                costTime: this.value1.split(' ')[0],   //消耗日期
                incomeTime: incomeTime,  // 收入时间，用于筛选小时数据
              })

          // 直接使用后端返回的数据
          this.tableData = response.data.data.data || []
          this.size = response.data.data.size || 0
          
          // 【优化】汇总行已由后端计算好，直接使用
          const summaryRow = this.normalizeSummaryRow(response.data.data.summaryRow || null, this.tableData)

          // 【优化】dataDetail 已由后端填充，无需再循环查询
          // 只需刷新表格布局
          this.$nextTick(() => {
            this.$refs.tableData1.doLayout();
          });

          // 获取状态信息（这部分仍需单独查询）
          this.fetchStatusForItems()
          this.fetchAutoStatusForItems()
          
          // 组装数据：汇总行 + 列表数据
          // 【修复】只要有汇总行就显示，不强制要求选择游戏
          if(summaryRow && Object.keys(summaryRow).length > 0){
            this.totalData = [summaryRow, ...this.tableData]
          } else {
            this.totalData = this.tableData
          }
          
          console.log("【优化版】数据加载完成", this.totalData)
          this.loading = false;
          
        } catch (error) {
          this.loading = false;
          console.error('数据加载失败:', error);
          this.$message.error('数据加载失败，请检查网络连接');
        }
      }
    },

    load(tree, treeNode, resolve) {

    },
    isFavorite(row) {
      return this.favorites.some(fav =>
          fav.accountId === row.accountId &&
          fav.promotionId === row.promotionId &&
          fav.materialId === row.materialId
      );
    },
    getStarColor(row) {
      const favorite = this.favorites.find(fav =>
          fav.accountId === row.accountId &&
          fav.promotionId === row.promotionId &&
          fav.materialId === row.materialId
      );
      return favorite ? favorite.starColor : '#C0C4CC';
    },  async toggleFavorite(row) {
      const isFav = this.isFavorite(row);
      if (isFav) {
        // 如果已收藏，移除收藏
        removeFavorite(row.accountId, row.promotionId, row.materialId);
      } else {
        // 如果未收藏，弹出颜色选择器让用户选择颜色
        const selectedColor = await this.selectStarColor();
        if (selectedColor) {
          addFavorite({
            accountId: row.accountId,
            promotionId: row.promotionId,
            materialId: row.materialId,
            starColor: selectedColor
          });
        }
      }
      this.favorites = getFavorites();
    },

    // 弹出颜色选择器
    selectStarColor() {
      return new Promise((resolve) => {
        this.$prompt('请选择星星颜色', '设置收藏颜色', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: 'color', // 使用 HTML5 颜色选择器
          inputValue: '#FFD700' // 默认颜色
        }).then(({ value }) => {
          resolve(value); // 返回用户选择的颜色
        }).catch(() => {
          resolve(null); // 用户取消选择
        });
      });
    }

  }
  ,
  updated() {

    this.$nextTick(() => {
      this.$refs['tableData1'].doLayout();
    })

  }
  ,
  mounted: function () {
    this.height = window.innerHeight;
    this.maxHeight = window.innerHeight - 250;
    this.favorites = getFavorites();
    // this.date_format_new()
    this.hourColumns = this.generateHourColumns()
    this.setToCurrentHourPoint()
    this.findGame()
    this.search(false)
    this.loadHourDisplaySettings(); //
    for (let i = 0, len = 160; i <= 160; i++) {
      this.items.push(i + '')
    }
  }


}
</script>
<style>


.promotion:hover {
  cursor: pointer;
  color: #3a8ee6;
}

.el-table .column-style {
  color: #4d7dd6;
  font-size: 12px;
  font-weight: bold;
}


.el-table .column-style3 {
  color: #d65055;
  font-size: 12px;
  font-weight: 600;
}

.el-table .column-style2 {
  color: #606266;
  font-size: 12px;

  border: 2px dashed #F00;
  border-right: 2px dashed #0F0 !important;
}

.el-progress-bar .el-progress-bar__inner {

  border-radius: inherit;

}

.el-progress-bar .el-progress-bar__outer {
  background-color: rgba(134, 116, 255, 0.54);
  border-radius: inherit;

}


.item {
  margin-top: 8px;
  margin-right: 10px;
  padding: 2px 2px;
}
</style>
<style type="text/css">

*::-webkit-scrollbar {
  width: 13px;
  height: 12px;
  background-color: transparent;
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
*::-webkit-scrollbar-track {
  background-color: #f0f6ff;
}

/*定义滚动条轨道 内阴影+圆角*/
*::-webkit-scrollbar-thumb {
  background-color: #b1b2b3;

}

/*定义滑块 内阴影+圆角*/
.scrollbarHide::-webkit-scrollbar {
  display: none
}

.scrollbarShow::-webkit-scrollbar {
  display: block
}

.bbb {
  //box-shadow: rgba(148,148,148,0.34) 0px 1px 3px 1px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .08);
  padding: 22px;
  border-radius: 8px;
  background-color: #FFFFFF;
  width: 97%;

  margin-top: 19px;

  display: flex;
  flex-direction: column;
}

.contain-6 {
  height: calc(100vh - 50px); /* 确保容器有明确的高度 */
  overflow-y: auto; /* 启用垂直滚动 */
}

.el-table {
  flex: 1; /* 让表格自动填充剩余空间 */
  min-height: 300px; /* 保证最小高度 */
}

</style>


<style scoped>
.scale-container {
  //transform: scale(0.9);
  //transform-origin: 0 0;
  //width: 111%;
  //height: 111%;
}
/* 汇总行基础样式 */
::v-deep .el-table .el-table__body-wrapper .summary-row {
  position: sticky !important;
  top: 0 !important;
  z-index: 100 !important; /* 汇总行层级 */
  background-color: #f0f9eb !important;
  font-weight: bold;

  //box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 固定列需要更高层级 */
::v-deep .el-table .el-table__fixed,
::v-deep .el-table .el-table__fixed-right {
  z-index: 105 !important; /* 固定列的z-index要高于汇总行 */
}

/* 固定列中的汇总行单元格 */
::v-deep .el-table .el-table__fixed .summary-row td,
::v-deep .el-table .el-table__fixed-right .summary-row td {
  z-index: 105 !important;
  //position: relative !important;
  background-color: #f0f9eb !important;
  position: sticky !important;
  //box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  top: 0 !important;
  font-weight: bold;
}

/* 确保固定列的表头也具有高优先级 */
::v-deep .el-table .el-table__fixed-header-wrapper,
::v-deep .el-table .el-table__fixed-right-header-wrapper {
  z-index: 106 !important; /* 表头固定列的z-index应该最高 */
}


/* 为固定列设置更高层级 */
::v-deep .el-table .el-table__body-wrapper .summary-row .is-fixed {
  z-index: 115 !important; /* 固定列需要更高层级 */
  position: sticky !important;

}

::v-deep .el-table .custom-fixed-column {
  z-index: 105 !important;

}

.el-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  max-height: 60vh;
  overflow-y: auto;
}

.el-checkbox {
  width: 280px;
  margin: 5px 10px;
}

/* 改变input框背景颜色 */
/deep/ .el-input__inner {
  background-color: rgba(240, 240, 240, 0.94);

}

/deep/ .el-range-input {
  background-color: rgba(240, 240, 240, 0.94);

}







</style>
